// extracted by mini-css-extract-plugin
export var bedroomsInfo = "ShipFacilityModal-module--bedrooms-info--14389";
export var colorLegend = "ShipFacilityModal-module--color-legend--d0b7b";
export var container = "ShipFacilityModal-module--container--d565c";
export var deckPlanSlider = "ShipFacilityModal-module--deck-plan-slider--4af8c";
export var group = "ShipFacilityModal-module--group--c2062";
export var leftSide = "ShipFacilityModal-module--left-side--80f6f";
export var legend = "ShipFacilityModal-module--legend--653a8";
export var raqContainer = "ShipFacilityModal-module--raq-container--182ef";
export var rightSide = "ShipFacilityModal-module--right-side--45ca7";
export var suiteFeatures = "ShipFacilityModal-module--suite-features--81916";
export var suitePlan = "ShipFacilityModal-module--suite-plan--226d1";
export var tabList = "ShipFacilityModal-module--tab-list--5ff18";
export var tabPanel = "ShipFacilityModal-module--tab-panel--21631";